import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-20 pb-10 px-4 bg-white" data-id="element-74">
      <div className="max-w-3xl mx-auto text-center" data-id="element-75">
        <p className="text-xs md:text-sm font-bold text-gray-500 uppercase tracking-widest mb-2" data-id="element-76">
          Las etapas de tus hijos no vuelven.
        </p>

        <h2 className="text-lg md:text-xl font-bold text-red-600 mb-3" data-id="element-77">
          Tus hijos están creciendo. Y cada día que pasa sin conectar de verdad…
          es un recuerdo que nunca se va a crear.
        </h2>

        <h1 className="text-3xl md:text-5xl font-black text-gray-900 mb-6 leading-tight" data-id="element-78">
          ❤️ PACK 100 CITAS
          <span className="block text-xl md:text-2xl text-blue-600 mt-2" data-id="element-79">
            Megapack Completo Mamá • Papá • Hijos
          </span>
        </h1>

        <button onClick={scrollToPricing} className="w-full max-w-xs md:max-w-sm mx-auto block cursor-pointer mb-6" data-id="element-80">
          <img src="https://cdn.magicpatterns.com/uploads/nJ6227LTvBcXZFid5u8iHs/MOCAP_100_CITAS.png" alt="Pack 100 Citas" width={384} height={384} decoding="async" className="w-full h-auto" data-id="element-81" />
        </button>

        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 mb-6 text-left md:text-center shadow-sm text-sm md:text-base" data-id="element-82">
          <p className="font-bold text-gray-800 mb-1" data-id="element-83">
            Momentos reales. Conexión profunda. Recuerdos que tus hijos van a
            guardar para siempre.
          </p>
          <p className="text-gray-700" data-id="element-84">
            Tiempo de calidad listo para usar. Sin pantallas. Sin planificar
            nada. Solo abrís, elegís y conectás.
          </p>
        </div>

        <CTAButton text="👉 QUIERO CREAR RECUERDOS CON MIS HIJOS" subtext="Descarga digital inmediata • Garantía de satisfacción de 7 días" data-id="element-85" />

        <p className="text-gray-500 italic text-xs mt-4" data-id="element-86">
          "Dentro de unos años vas a agradecer haber creado estos momentos."
        </p>
      </div>
    </section>;
}